/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

import { LCD_SETUP } from './microbitBlocks';

// Comparte la clave de setup con microbit_lcd_i2c_2: es la misma pantalla, así
// que inicializarla dos veces no compila.
export const lcd_clear = (block, generator) => {
  generator.setups_['microbit_lcd_i2c_2'] = LCD_SETUP;

  return '\n  I2C_LCD1602.clear()\n  ';
};

// Los dos comparten la clave de setup con microbit_lcd_i2c_2: es la misma
// pantalla, inicializarla dos veces no compila.
export const microbit_lcd_i2c_clear_2 = (block, generator) => {
  generator.setups_['microbit_lcd_i2c_2'] = LCD_SETUP;

  return '\n  I2C_LCD1602.clear()\n  ';
};

export const microbit_lcd_i2c_setBacklight = (block, generator) => {
  const state = block.getFieldValue('STATE');

  generator.setups_['microbit_lcd_i2c_2'] = LCD_SETUP;

  return `\n  I2C_LCD1602.backlight(${state})\n  `;
};
